<template>
  <div class="content">
    <h3>Integrador</h3>
    <div class="line">
      <b>Token:</b> <br/><input disabled type="text" class="inputWire" v-model="token"/>
      <br/><br/>
      <b>Lista de EAN:</b> <br/>Os EAN listados abaixo serão ignorados na integração<br/><textarea placeholder="Exemplo: 0123456789123, 0123456789123, 0123456789123" style="width:450px;height:165px;" type="text" class="inputWire" v-model="ean_black_list"/>
      <br/><br/>
      <button @click="saveIntegrationConfig()">Salvar</button>
    </div>
  </div>

</template>

<script>
  import {mapGetters} from 'vuex'
  import {EventBus} from '@/utils/event-bus'
  import IntegratorConn from '@/connection/integrator'

  export default {
    data() {
      return {
        ean_black_list: null,
        token: null
      }
    },

    created() {
      this.getIntegrationConfig()
    },

    computed: {
      ...mapGetters(['getOpaApi', 'getIntegratorApi']),
    },

    methods: {
      async getIntegrationConfig() {
        EventBus.$emit('showLoading', true)
        let result = await IntegratorConn.getIntegrationConfig()
        if (result.error) {
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', result.msg)
        } else {
          EventBus.$emit('showLoading', false)
          if (!result.token) {
            EventBus.$emit('showAlert', 'error', 'Você não possui integrador ativo, entre em contato com comercial@opabox.com.br')
          } else {
            this.ean_black_list = result.ean_black_list ? result.ean_black_list.join(',') : ''
            this.token = result.token
          }
        }
      },

      async saveIntegrationConfig() {
        EventBus.$emit('showLoading', true)
        if (!this.ean_black_list) {
          this.ean_black_list = []
        } else {
          this.ean_black_list = this.ean_black_list.replace(/\s/g, '')
          this.ean_black_list = this.ean_black_list.split(',')
        }
        let result = await IntegratorConn.saveIntegrationConfig(this.ean_black_list)
        EventBus.$emit('showLoading', false)
        if (!result.error) {
          this.ean_black_list = result.ean_black_list.join(',')
          EventBus.$emit('showAlert', 'success', 'Integrador  atualizado!')
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    }
  }
</script>
